import React, { useState, useRef } from 'react';
import Papa from 'papaparse';

import { OverTimeButton } from "../../StyledComponents";

const CsvModuleBuilder = ({handleUploadSuccess}) => {
    const [formulas, setFormulas] = useState([]);
    const inputRef = useRef(null);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];

        if (file) {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    const data = results.data;
                    const generatedFormulas = generateFormulas(data);
                    setFormulas(generatedFormulas);
                    handleUploadSuccess(generatedFormulas);
                },
            });
        }
    };

    const generateFormulas = (data) => {
        const formulaObjects = [];

        data.forEach((row) => {
            const valuePath = row['values'];

            Object.keys(row).forEach((key) => {
                if (key !== 'values' && row[key]) {
                    const condition = row[key];
                    const formulaName = `is${key.replace(/\s+/g, '')}`;
                    const moduleName = key.replace(/\s+/g, '').replace(/^./, str => str.toLowerCase());

                    const existingFormula = formulaObjects.find(f => f.name === formulaName);

                    if (existingFormula) {
                        existingFormula.conditions.push(`${valuePath.trim()} ${condition.trim()}`);
                    } else {
                        formulaObjects.push({
                            name: formulaName,
                            moduleName,
                            conditions: [`${valuePath.trim()} ${condition.trim()}`],
                        });
                    }
                }
            });
        });

        return formulaObjects.map(({ name,moduleName, conditions }) => {
            const sanitizedConditions = conditions.map(cond => {
                return cond.replace(/&&/g, ' && ').replace(/\|\|/g, ' || ').trim();
            });
            const conditionsString = sanitizedConditions.map(cond => {
                const [path, condition] = cond.split(/\s(.+)/);
                return `(${condition.split('&&').map(c => `(values.${path.trim()} ${c.trim()})`).join(' && ')})`;
            }).join(' && ');

            const funcStr = `return ${conditionsString};`;
            //console.log("funcStr", funcStr);
            return {
                formulaName: name,
                moduleName,
                function: new Function('values', funcStr)
            };
        });
    };

    return (
        <OverTimeButton style={{borderRadius: 0}} onClick={()=>{
            inputRef.current.click();
        }}>
           +
            <input ref={inputRef} style={{display: "none"}} type="file" accept=".csv" onChange={handleFileUpload} />
        </OverTimeButton>
    );
};

export default CsvModuleBuilder;
